import { useResponsive } from "hooks";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";
import {
  Box,
  Paper,
  Slide,
  Stack,
  Typography,
  IconButton,
} from "@mui/material";

import PlaylistAddCheckRoundedIcon from "@mui/icons-material/PlaylistAddCheckRounded";
import ChecklistRoundedIcon from "@mui/icons-material/ChecklistRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import SupportAgentRoundedIcon from "@mui/icons-material/SupportAgentRounded";
import AccountBalanceWalletRoundedIcon from "@mui/icons-material/AccountBalanceWalletRounded";

export default function Controller() {
  return <Footer />;
}

function Footer() {
  const isMobile = useResponsive("down", "sm");
  return (
    <Slide direction="up" in={isMobile}>
      <Box
        height={64}
        component="footer"
        sx={{
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1000,
          position: "fixed",
        }}
      >
        <Paper
          sx={{
            color: "#fff",
            height: "100%",
            borderRadius: 0,
            bgcolor: "primary.main",
            backdropFilter: "blur(6px)",
            WebkitBackdropFilter: "blur(6px)",
          }}
        >
          <Stack
            p={1}
            pb={2}
            height="100%"
            direction="row"
            alignItems="center"
            justifyContent="space-around"
          >
            <Stack alignItems="center">
              <IconButton
                size="small"
                to="/main/announcement"
                color="inherit"
                LinkComponent={Link}
              >
                <ChecklistRoundedIcon />
              </IconButton>
              <Typography variant="caption" fontSize={10}>
                سفارشات
              </Typography>
            </Stack>
            <Stack alignItems="center">
              <IconButton
                size="small"
                to="/"
                color="inherit"
                LinkComponent={Link}
              >
                <PlaylistAddCheckRoundedIcon />
              </IconButton>
              <Typography variant="caption" fontSize={10}>
                محصولات
              </Typography>
            </Stack>
            <Stack alignItems="center">
              <IconButton
                to="/"
                color="inherit"
                LinkComponent={Link}
                sx={{ bgcolor: "action.hover" }}
              >
                <HomeRoundedIcon />
              </IconButton>
              <Typography variant="caption" fontSize={10}>
                خانه
              </Typography>
            </Stack>
            <Stack alignItems="center">
              <IconButton
                size="small"
                to="/"
                color="inherit"
                LinkComponent={Link}
              >
                <AccountBalanceWalletRoundedIcon />
              </IconButton>
              <Typography variant="caption" fontSize={10}>
                کاربران
              </Typography>
            </Stack>
            <Stack alignItems="center">
              <IconButton
                size="small"
                to="/"
                color="inherit"
                LinkComponent={Link}
              >
                <SupportAgentRoundedIcon />
              </IconButton>
              <Typography variant="caption" fontSize={10}>
                فروشگاه ها
              </Typography>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </Slide>
  );
}
